export default "assets/images/icons/twitter-4c2fe650.svg";